import React, {Fragment, useState} from 'react'
import {Form, Input, Button, message, Select,} from 'antd';
import {reqGnArea} from '../../api'
import {convertToOptions} from "../../components/options";

//地址组件
export default function Address(props) {
    let timeout;
    let currentValue;
    const [city, setCity] = useState('');
    const [data, setData] = useState([]);

    function fetch(value, callback) {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        currentValue = value;

        async function fake() {
            let result = await reqGnArea({city: value})
            if (result.code === 200) {
                setData(result.data)
            } else {
                message.error(result.message)
            }
        }

        timeout = setTimeout(fake, 300);
    }

    const handleSearch = value => {
        if (value) {
            fetch(value, data => setData(data));
        } else {
            setData([])
        }
    };
    const handleChange = value => {
        setCity(value)
        const provinceArray = data.filter(o => o.city === value);
        if (provinceArray.length > 0) {
            props.setFieldsValue({[props.name + '.province']: provinceArray[0].province})
        }
    };
    const addrFormItemLayout = {
        labelCol: {lg: {span: 4}, md: {span: 8},},
        wrapperCol: {lg: {span: 19}, md: {span: 15},},
    }
    return <Fragment>
        地址{props.indx + 1}{props.address && props.address.default ? '(默认)' : ''}
        <Button type='link' onClick={() => props.delAddr(props.type, props.indx)}>删除</Button>
        <div className='domestic-margin domestic-box'>
            <Form.Item label="地址" {...addrFormItemLayout}>
                {props.getFieldDecorator(props.name + '.city', {
                    rules: [{required: true, message: '该项必填'}]
                })(<Select
                    showSearch
                    value={city}
                    placeholder='请输入城市'
                    defaultActiveFirstOption={false}
                    optionLabelProp="value"
                    showArrow={false}
                    filterOption={false}
                    onSearch={handleSearch}
                    onChange={handleChange}
                    notFoundContent={null}
                >
                    {convertToOptions(data, 'city', 'city', 'province', 'city')}
                </Select>)}
                {props.getFieldDecorator(props.name + '.province', {
                    rules: [{required: true, message: '该项必填'}]
                })(<input type='hidden'/>)}
            </Form.Item>
            <div className="ant-col ant-form-item-label ant-col-md-8 ant-col-lg-4"></div>
            <Form.Item label="" {...addrFormItemLayout}>
                {props.getFieldDecorator(props.name + '.address', {
                    rules: [{required: true, message: '该项必填'}]
                })(<Input placeholder='请输入详细地址'/>)}
            </Form.Item>
            <Form.Item label="联系人" {...addrFormItemLayout}>
                {props.getFieldDecorator(props.name + '.contactName', {
                    rules: [{required: true, message: '该项必填'}]
                })(<Input placeholder='请输入联系人' style={{width: '40%', marginRight: '5%'}}/>)}
                {props.getFieldDecorator(props.name + '.contackPhone', {
                    rules: [{required: true, message: '联系人电话或手机必填'}]
                })(<Input placeholder='请输入联系人电话或手机' style={{width: '55%'}}/>)}
            </Form.Item>
        </div>
    </Fragment>
}